export default {
  headText: "klang im Detail",
  headSubtext:
    "Von einem Unfall eines Versicherten bzw. Anspruchstellers erfahren Sie als Versicherer häufig zu spät - oftmals erst nach Abschluss der Reha-Behandlung.",
};
